import React, { useState, useEffect } from "react";
import { Pie } from "react-chartjs-2";
import { Skeleton, Spin } from "antd";
import { useTheme } from "../../utils/ThemeContext";
import { MODULE_API } from "../../apis";
import { chartColors } from "../form/debtPayOff/components/color";
export const NetWorthBudgetGraph = ({ goalsData, loading }) => {
  const { theme } = useTheme();
  const [totalSavings, setTotalSaving] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const getUserTotalMonthlySaving = async () => {
    try {
      setIsLoading(true);
      let datares = await MODULE_API.fetchUserMontlhySaving();
      if (datares && datares.message) {
        const filtered = datares.message;
        // const totalMonthlySaving = filtered.reduce(
        //   (sum, item) => sum + (item.total_monthly_saving_goals || 0),
        //   0
        // );

        // console.log("totalMonthlySaving", filtered);
        setTotalSaving(filtered);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getUserTotalMonthlySaving();
  }, []);
  const moduleTotals = Array.isArray(totalSavings)
    ? totalSavings.reduce((acc, item) => {
        if (!acc[item.module_name]) {
          acc[item.module_name] = 0;
        }
        acc[item.module_name] += item.total_monthly_saving_goals;
        return acc;
      }, {})
    : {};

  // Step 2: Build chart data from grouped object
  const moduleNames = Object.keys(moduleTotals);
  const moduleValues = Object.values(moduleTotals);
  const dataDonut = {
    labels: moduleNames || [],
    datasets: [
      {
        data: moduleValues || [],
        backgroundColor: moduleNames.map(
          (_, index) => chartColors[index % chartColors.length]
        ),
      },
    ],
  };

  // const dataDonut = {
  //   labels: [
  //     "Wedding",
  //     "Vacation",
  //     "Investment Property",
  //     "Trip to Scotland",
  //     "Retirement",
  //     "Unallocated",
  //   ],
  //   datasets: [
  //     {
  //       data: [1600, 750, 1000, 1250, 5000, 2885],
  //       backgroundColor: [
  //         "#1E56A0",
  //         "#4DA1A9",
  //         "#3CAEA3",
  //         "#8AC926",
  //         "#A3EB80",
  //         "#FF5A5F",
  //       ],
  //     },
  //   ],
  // };

  const totalMonthlySavings = totalSavings
    ? totalSavings.reduce(
        (sum, item) => sum + item.total_monthly_saving_goals,
        0
      )
    : 0;
  const showInitialSkeleton =
    (isLoading || loading) && (!totalSavings || totalSavings.length === 0);
  return (
    <div
      className="budgetMaincards netWorthCard"
      style={{
        width: "100%",
        padding: "0px",
        borderRadius: "8px",
        backgroundColor: theme === "dark" ? "#232323" : "white",
        position: "relative",
      }}
    >
      <h2
        style={{
          fontSize: "1.5rem",
          fontWeight: "bold",
          color: theme === "light" ? "#232323" : "white",
        }}
      >
        Goal Monthly Savings
      </h2>
      <p
        style={{
          fontSize: "1.2rem",
          color: theme === "light" ? "#232323" : "white",
        }}
      >
        Monthly Savings: $
        {totalMonthlySavings.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
      </p>

      <div style={{ display: "flex", marginTop: "1rem", minHeight: "220px" }}>
        {showInitialSkeleton ? (
          <div style={{ width: "100%" }}>
            <Skeleton active paragraph={{ rows: 6 }} title={false} />
          </div>
        ) : (
          <Pie
            data={dataDonut}
            options={{
              legend: {
                display: true,
                position: "right",
                labels: {
                  font: {
                    size: 14,
                  },
                  usePointStyle: true,
                },
              },
              plugins: {},
            }}
          />
        )}
      </div>
      {(isLoading || loading) && totalSavings && totalSavings.length > 0 ? (
        <div style={{ marginTop: "12px", display: "flex", justifyContent: "center", alignItems: "center", minHeight: "64px", borderRadius: "12px", border: "1px solid rgba(74, 98, 255, 0.35)", background: "linear-gradient(135deg, rgba(42, 61, 163, 0.16), rgba(42, 61, 163, 0.06))", boxShadow: "inset 0 1px 0 rgba(255,255,255,0.14)" }}>
          <Spin size="large" />
        </div>
      ) : null}
    </div>
  );
};
